import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnProp, AsnPropTypes, AsnIntegerArrayBufferConverter, } from "@peculiar/asn1-schema";
import { Convert } from "pvtsutils";
export const id_caVersion = "1.3.6.1.4.1.311.21.1";
let CaVersion = class CaVersion {
    constructor() {
        this.value = new ArrayBuffer(0);
    }
    toString() {
        const version = this.getVersion();
        return `V${version.certificateIndex}.${version.keyIndex}`;
    }
    getVersion() {
        let data = new Uint8Array(this.value);
        if (this.value.byteLength < 4) {
            data = new Uint8Array(4);
            data.set(new Uint8Array(this.value), 4 - this.value.byteLength);
        }
        return {
            keyIndex: parseInt(Convert.ToHex(data.slice(0, 2)), 16),
            certificateIndex: parseInt(Convert.ToHex(data.slice(2)), 16),
        };
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], CaVersion.prototype, "value", void 0);
CaVersion = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], CaVersion);
export { CaVersion };
